import { Box, FormControl, FormLabel, Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { FC } from "react";
import { QuestionnaireItemProps } from ".";
import DateOptions from "../../../../../components/form/inputs/DateOptions";

const DateQuestion: FC<QuestionnaireItemProps> = ({
  item,
  onChange,
  value,
  initialValue,
  disabled,
  required,
}) => {
  // this breaks if the question changes
  // use isDateOption as default,
  const isDateOption = true;
  // const isDateOption = [
  //   "Last Menstrual Period (First day of last period)?",
  //   "Last Pap Test?",
  //   "Most recent HIV test date",
  // ].includes(item.text);

  return (
    <Grid>
      <FormControl fullWidth>
        <FormLabel required={required}>{item.text}</FormLabel>

        {isDateOption ? (
          <Box mt={1}>
            <DateOptions
              date={value?.value}
              onDateChange={(date) =>
                onChange(item, { answerObj: { ...value, value: date } })
              }
              onValueTypeChange={(valueType) =>
                onChange(item, { answerObj: { ...value, valueType } })
              }
              valueType={value?.valueType}
            />
          </Box>
        ) : (
          <DatePicker
            value={value?.value || initialValue || null}
            onChange={(date) => onChange(item, date)}
            renderInput={(props) => (
              <TextField
                {...props}
                size="small"
                InputLabelProps={{ shrink: true }}
              />
            )}
            disabled={disabled}
            inputFormat="dd/MM/yyyy"
          />
        )}
      </FormControl>
    </Grid>
  );
};

export default DateQuestion;
